'use strict';

import React from 'react';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { GlobalHeader, StyledHeader } from './Header.styles';
import Menu from './components/Menu/Menu.jsx';
import CookieMessage from '../ApplicationHandler/CookieMessage';
import SkipLinks from '../SkipLinks/SkipLinks';

class Header extends React.Component {
    render() {
        return (
            <StyledHeader>
                <CookieMessage />
                <SkipLinks />
                <PlayContainerBase>
                    <GlobalHeader className="lp_head">
                        <Menu />
                    </GlobalHeader>
                </PlayContainerBase>
            </StyledHeader>
        );
    }
}

export default Header;
